<template lang="pug">
.dialog(v-if="value")
  .dialog__overlay
  .dialog__view
    .dialog__header
      .dialog__title
        slot(name="title")
          span Диалог
      .dialog__close(@click="close")
        svg(xmlns="http://www.w3.org/2000/svg", fill="none", viewBox="0 0 330 329")
          defs
          path(fill="#F44336" fill-rule="evenodd" :d="d" clip-rule="evenodd")
    .dialog__message
      slot
        span Неизвестное сообщение
    .dialog__controls
      .dialog__button.dialog__button-no.btn.button_primary-outline(@click="reject")
        slot(name="reject")
          span Нет
      .dialog__button.dialog__button-yes.btn.button_primary(@click="resolve")
        slot(name="resolve")
          span Да
</template>

<script>
export default {
  name: 'VbDialog',
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    // eslint-disable-next-line max-len
    d: 'M299.77 327.78a21.25 21.25 0 008.16 1.62v.01a21.2 21.2 0 0015.09-6.25 21.31 21.31 0 000-30.16L194.8 164.77 323 36.56a21.31 21.31 0 00-23.24-34.79 21.31 21.31 0 00-6.92 4.63L164.63 134.61 36.42 6.39a21.31 21.31 0 00-34.8 6.92 21.3 21.3 0 004.63 23.24l128.22 128.22L6.26 292.98a21.3 21.3 0 0015.08 36.42 21.22 21.22 0 0015.08-6.25l128.21-128.21 128.22 128.21a21.27 21.27 0 006.92 4.63z',
  }),
  methods: {
    reject() {
      this.$emit('reject');
      this.close();
    },
    resolve() {
      this.$emit('resolve');
      this.close();
    },
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.dialog {
  position: fixed;
  top: 0; bottom: 0;
  left: 0; right: 0;
  z-index: 20;
  &__overlay {
    position: absolute;
    z-index: 1;
    top: 0; bottom: 0;
    left: 0; right: 0;
    background-color: rgba(0, 0, 0, .75);
  }
  &__view {
    position: fixed;
    z-index: 2;
    left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    background-color: rgb(255, 255, 255);
    width: auto;
    min-width: 300 / 16 + rem;
    max-width: 500 / 16 + rem;
    min-height: 100 / 16 + rem;
    max-height: 80%;
    border-radius: 5 / 16 + rem;
    padding: 20 / 16 + rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  &__header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  // __title __close __message __controls __button
  &__title {
    margin-right: 16 / 16 + rem;
    font-weight: 500;
    font-size: 32 / 16 + rem;
  }
  &__close {
    cursor: pointer;
    width: 20 / 16 + rem;
    height: 20 / 16 + rem;
    transition: all .25s ease;
    &:hover {
      transform: rotate(180deg);
    }
  }
  &__message {
    font-size: 18 / 16 + rem;
    line-height: 25 / 16 + rem;
    padding: 30 / 16 + rem 0;
  }
  &__controls {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  &__button {
    min-width: 100 / 16 + rem;
    &:first-child {
      margin-right: 20px;
    }
  }
}
</style>
